export default __webpack_public_path__ + "media/images/airplane-0b6333bb63b51b41e6b0fc1931090400.png";